import React from 'react';
import { Grid } from '@mui/material';
import FormCard from 'pages/provisioning/_components/FormCard';
import Form from 'pages/provisioning/virtual-service/components';
import StaticText from 'shared/Common/StaticText/StaticText';
import { orderPayload, validVSForm, selectedVSService, toggleQuickConfig, isValidCostCenter } from 'pages/provisioning/virtual-service/store';
import { useRecoilValue, useRecoilState } from 'recoil';
import useAksKeyvaultDetails from 'pages/provisioning/virtual-service/hooks/useAksKeyvaultDetails';
import BudgetCodeValidationModal from 'pages/provisioning/_components/StackProvisioning/Form/BudgetCodeValidationModal';

const ApplicationForm = () => {
    const [order, setOrder] = useRecoilState(orderPayload);
    const [budgetCodeValidation, setBudgetCodeValidation] = React.useState({ open: false, budgetCode: null });
    const [, setValidCostCenter] = useRecoilState(isValidCostCenter);
    const validForm = useRecoilValue(validVSForm);
    const selectedVS = useRecoilValue(selectedVSService);
    const isOpen = useRecoilValue(toggleQuickConfig);
    useAksKeyvaultDetails();

    const isUpdate = order?.aksVirtualServiceRequestType === 'UPDATE' && validForm?.isNamespaceExists;
    const isCreateWithCustomDomain =
        order?.aksVirtualServiceRequestType === 'CREATE' &&
        order?.aksVirtualService?.some((item, index) => (isOpen && index === selectedVS ? false : item?.customDomainSelected === 'Yes'));
    const showKeyvaultDetails = isUpdate || isCreateWithCustomDomain;

    const handleBudgetCodeFailure = ({ budgetCode }) => setBudgetCodeValidation({ open: true, budgetCode });

    const closeBudgetCodeValidation = (isAccepted) => {
        if (isAccepted) setOrder((prev) => ({ ...prev, enabledManualBudgetCode: true }));
        setValidCostCenter(isAccepted);
        setBudgetCodeValidation({ open: false, budgetCode: null });
    };

    return (
        <FormCard title="Application ">
            <Grid item container spacing={2}>
                {/* <Grid item xs={12} sm={6} md={6}>
                        <Form.Sector />
                    </Grid> */}
                {/* <Form.Division /> */}
                {/* <Form.ApplicationRegion /> */}
                <Grid item xs={12} sm={6} md={6}>
                    <Form.Environment />
                </Grid>
                <Form.Region />
                {/* <Form.Program /> */}
                <Grid item xs={12} sm={6} md={6}>
                    <Form.ApplicationService />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <Form.BusinessCategory />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <Form.ApplicationOwner />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <Form.CostCenter onBudgetCodeValidationFailure={handleBudgetCodeFailure} />
                </Grid>
                {/* <Grid item xs={12} sm={6} md={6}>
                        <Form.CertificateOwnerOne />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <Form.CertificateOwnerTwo />
                    </Grid> */}
                <Grid item xs={12} sm={6} md={6}>
                    <Form.ADCertGroup />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <Form.AppSupportMailIdDL />
                </Grid>

                {/* <Grid item xs={12} sm={6} md={6}>
                        <Form.Department />
                    </Grid> */}
                {/* <Grid item xs={12} sm={6} md={6}>
                        <Form.AksCluster />
                    </Grid> */}
                <Grid item xs={12} sm={6} md={6}>
                    <Form.AksNamespace />
                </Grid>
                {showKeyvaultDetails && (
                    <>
                        <Grid item xs={12} sm={6} md={6}>
                            <StaticText label="Key Vault Name *" value={order?.keyVaultName} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <StaticText label="SPC Name *" value={order?.spcName} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <StaticText label="Key Vault Region *" value={order?.keyVaultRegion} />
                        </Grid>
                    </>
                )}
            </Grid>
            <Grid item xs={4}>
                <BudgetCodeValidationModal
                    open={budgetCodeValidation.open}
                    budgetCode={budgetCodeValidation.budgetCode}
                    onContinue={() => closeBudgetCodeValidation(true)}
                    onCancel={() => closeBudgetCodeValidation(false)}
                />
            </Grid>
        </FormCard>
    );
};

export default ApplicationForm;
